'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _domElement = require('../../utils/propTypes/domElement');

var _domElement2 = _interopRequireDefault(_domElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PortalLayer = function (_React$Component) {
  _inherits(PortalLayer, _React$Component);

  function PortalLayer() {
    _classCallCheck(this, PortalLayer);

    return _possibleConstructorReturn(this, (PortalLayer.__proto__ || Object.getPrototypeOf(PortalLayer)).apply(this, arguments));
  }

  _createClass(PortalLayer, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _props = this.props,
          element = _props.element,
          renderTree = _props.renderTree;

      var closeTransitionTree = renderTree(null, true);
      if (!closeTransitionTree) return;
      var originalTransitionContents = Array.prototype.map.call(element.firstChild.children, function (childElement) {
        return childElement.cloneNode(true);
      });
      var closeTransitionContainer = document.createElement('div');
      element.appendChild(closeTransitionContainer);
      (0, _reactDom.render)(closeTransitionTree, closeTransitionContainer, function () {
        originalTransitionContents.forEach(function (el) {
          return closeTransitionContainer.firstChild.appendChild(el);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          element = _props2.element,
          renderTree = _props2.renderTree;

      var tree = renderTree(children);
      return (0, _reactDom.createPortal)(tree, element);
    }
  }]);

  return PortalLayer;
}(_react2.default.Component);

PortalLayer.propTypes = {
  children: _propTypes2.default.node.isRequired,
  element: _domElement2.default.isRequired,
  renderTree: _propTypes2.default.func.isRequired
};

exports.default = PortalLayer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/layer/internal/PortalLayer.js
// module id = 543
// module chunks = 177